(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.feeder-report.view
    (:require
     [clojure.string :as string]
     [frontend.ui.page.lp-portal.report.view :as report-view]
     [frontend.ui.page.lp-report-editor.common.event :as common-event]
     [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
     [frontend.ui.page.lp-report-editor.common.view :refer [close-button
                                                            footer
                                                            preview-pdf-button]]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.buttons :as buttons]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.feeder-report.event :as event]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
     [frontend.ui.page.lp-report-editor.style :as editor-style]
     [frontend.ui.page.lp-report-editor.sub :as editor-sub]
     [herb.core :refer [<class]]
     [re-frame.core :as rf]))

(defn step-footer
  [report]
  (let [rid (:db/id report)
        can-edit-text? @(rf/subscribe [::sub/has-edit-feeder-texts-access?])
        can-approve-text? @(rf/subscribe [::sub/can-approve-feeder-texts?])
        can-edit-data? @(rf/subscribe [::sub/has-edit-feeder-data-access?])
        can-approve-data? @(rf/subscribe [::sub/can-approve-feeder-data?])
        text-reject-recipients @(rf/subscribe [::sub/text-reject-recipients rid])
        text-submit-recipients @(rf/subscribe [::sub/text-submit-recipients rid])
        data-reject-recipients @(rf/subscribe [::sub/data-reject-recipients rid])
        data-submit-recipients @(rf/subscribe [::sub/data-submit-recipients rid])
        feeder-report-rich-content-list @(rf/subscribe [::sub/feeder-report-rich-content-list])
        feeder? true]
    [footer
     {:left-content
      [:<>
       [close-button {:on-click #(rf/dispatch [::event/close-viewer])}]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report report
          :feeder? feeder?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview report feeder?])}]]]

      :right-content
      [:<>
       ;; text buttons
       [buttons/fund-text-buttons
        feeder?
        report
        text-submit-recipients
        feeder-report-rich-content-list
        [::event/submit-for-review-text rid]
        [::event/submit-for-review-text-confirm rid]
        text-reject-recipients
        [::event/reject-text rid]
        [::event/on-reject-confirmed rid]
        [::event/approve-text rid]
        can-edit-text?
        can-approve-text?]

       ;; data buttons
       [buttons/fund-data-buttons
        report
        data-submit-recipients
        [::event/submit-for-review-data rid]
        [::event/submit-for-review-data-confirm rid]
        data-reject-recipients
        [::event/reject-data rid]
        [::event/reject-data-confirm rid]
        [::event/approve-data rid]
        can-edit-data?
        can-approve-data?]]}]))

(defn view
  []
  (let [feeder-report-id (:db/id (first @(rf/subscribe [::editor-sub/feeder-reports])))
        feeder-report @(rf/subscribe [::editor-sub/report feeder-report-id])
        feeder-report-ui-data @(rf/subscribe [::editor-sub/feeder-report-ui-data feeder-report-id])
        can-edit? @(rf/subscribe [::sub/can-edit-feeder-texts?]) ;; TODO --> allow only when in WIP +
        can-edit-footer? @(rf/subscribe [::sub/can-edit-feeder-footer-texts?])
        ;; contributor / reviewer
        save-text
        (fn [edit-path edit-value complete-path complete-status]
          (rf/dispatch [::event/save-fund-report-text feeder-report-id edit-path
                        edit-value complete-path complete-status]))
        wip-data? (= :lp-report.publishing-status/wip (:lp-report/data-status feeder-report))]
    [:<>
     (when wip-data?
       [:div
        {:class (<class editor-style/page-watermark-container)}
        [:div
         {:class (<class editor-style/page-watermark)}
         (->> (range 0 2000)
              (map (fn [_i]
                     "Draft data"))
              (string/join " - "))]])
     [:div
      {:class (<class editor-style/page-body)}
      [:div
       {:class (<class editor-style/page-content)}
       [report-view/fund-report-content
        {:fund-ui-data       feeder-report-ui-data
         :report             feeder-report
         :fund-template-type (:lp-report/template-type feeder-report)
         :edit-mode?         can-edit?
         :show-draft?        true
         :edit-mode-footer?  can-edit-footer?
         :save-text          save-text}]]]
     [step-footer feeder-report]]))
